import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api, type RoomSummary } from '../net/api';
import { Button } from '../components/Button';
import { Card } from '../components/Card';
import { Logo } from '../components/Logo';
import { useRoomStore } from '../store/roomStore';

export function Join() {
  const { code: rawCode = '' } = useParams();
  const code = rawCode.toUpperCase();
  const navigate = useNavigate();
  const [room, setRoom] = useState<RoomSummary | null>(null);
  const [name, setName] = useState('Player');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const token = localStorage.getItem(`cc:room:${code}`);
    if (token) { navigate(`/room/${code}`, { replace: true }); return; }
    void api.room(code).then((summary) => setRoom(summary)).catch((reason) => setError(reason instanceof Error ? reason.message : 'Could not check the room.')).finally(() => setLoading(false));
  }, [code, navigate]);
  const join = async () => {
    if (!name.trim()) return;
    setLoading(true);
    try {
      const token = await useRoomStore.getState().join(code, name.trim());
      localStorage.setItem(`cc:room:${code}`, token);
      navigate(`/room/${code}`, { replace: true });
    } catch (reason) { setError(reason instanceof Error ? reason.message : 'Could not join.'); setLoading(false); }
  };
  const unavailable = room?.status === 'not_found' ? "That room doesn't exist (anymore)." : room && !room.joinable ? 'This game is already full.' : null;
  return <main className="center-page"><Card className="join-card"><Logo compact />{loading && !room ? <p>Checking room…</p> : error || unavailable ? <><h1>Can’t join</h1><p>{error ?? unavailable}</p><Link to="/"><Button>Take me home</Button></Link></> : <><p className="eyebrow">Joining {room?.creatorName}</p><h1>Room {code}</h1><label>Your display name<input value={name} maxLength={14} onChange={(event) => setName(event.target.value)} onKeyDown={(event) => { if (event.key === 'Enter') void join(); }} /></label><Button block disabled={loading || !name.trim()} onClick={() => void join()}>{loading ? 'Joining…' : 'Join game'}</Button><small className="privacy-note">No account, cookies, or personal information beyond this display name.</small></>}</Card></main>;
}
